import { FC, useEffect, useRef, useState } from "react";
import { Box, Stack, SystemProps, Text } from "@storyofams/react-ui";
import { useRouter } from "next/router";
import { ProductOption } from "~lib/shopify/sdk";
import { SingleVariant } from "../SingleVariant";
import { OptionTitle } from "./OptionTitle";

interface RegularOptionProps extends SystemProps {
  autoDiscount: string | null;
  refillVariants: any[];
  regularVariants: any[];
  options: Pick<ProductOption, "name" | "values">[];
  mostPopularVariant: string;
}
export const RegularOptions: FC<RegularOptionProps> = ({
  refillVariants,
  regularVariants,
  autoDiscount,
  options,
  mostPopularVariant,
  ...props
}) => {
  const [pickedMainOption, setPickedMainOption] = useState(
    regularVariants[0][0]
  );
  const { isReady, query } = useRouter();
  const ref = useRef(true);
  useEffect(() => {
    if (isReady && query.variantId && ref.current) {
      ref.current = false;
      let index = 0;
      regularVariants.forEach((item, i) => {
        const foundOption = item[1]?.find((option) =>
          option?.id?.includes(query.variantId)
        );
        if (foundOption) index = foundOption.selectedOptions[0].value;
      });
      setPickedMainOption(index);
    }
  }, [isReady, query.variantId]);
  const handleMainOptionClick = (title) => setPickedMainOption(title);
  const currentOptions = regularVariants.filter(
    (item) => item[0] === pickedMainOption
  )[0];
  const currentRefillOptions = refillVariants.filter(
    (item) => item[0] === pickedMainOption
  )[0];
  return (
    <Box {...props}>
      <Text color={"#767473"} fontSize={"14px"} mb={1}>
        {options[0].name}
      </Text>
      <Stack mb={[5, 5]} space={1} flexDirection={["column", "row"]}>
        {regularVariants.map(([title]) => (
          <OptionTitle
            title={title}
            key={title}
            isPicked={title === pickedMainOption}
            onOptionClick={handleMainOptionClick}
          />
        ))}
      </Stack>
      <Text color={"#767473"} fontSize={"14px"} mb={1}>
        {options[1].name}
      </Text>
      <Stack flexDirection={"column"} space={1}>
        {currentOptions &&
          currentOptions[1] &&
          currentOptions[1].map((item) => (
            <SingleVariant
              option={item}
              autoDiscount={autoDiscount}
              key={item.id}
              mostPopularVariant={mostPopularVariant}
            />
          ))}
      </Stack>
      <Stack flexDirection={"column"} space={1}>
        {currentRefillOptions &&
          currentRefillOptions[1] &&
          currentRefillOptions?.map((item) => (
            <SingleVariant
              option={item}
              autoDiscount={autoDiscount}
              key={item.id}
              mostPopularVariant={mostPopularVariant}
            />
          ))}
      </Stack>
    </Box>
  );
};
